import * as React from 'react';
import ToolTip from '@appComponents/ToolTip/ToolTip';
import ReportFeedForm from './ReportFeedForm';
import { LightboxComponent } from '../LightboxComponent/LightboxComponent';
import IReportFeed, { TReportFeed } from './IReportFeed';

import * as style from './ReportFeedStyle.module.scss'

export default class ReportFeed extends React.Component<IReportFeed, TReportFeed> {

  state: TReportFeed = {
    isVisible: false,
  };

  toggleVisibility = () => {
    this.setState({ isVisible: !this.state.isVisible });
  }

  render() {
    return (
      <div className={style.report}>
        <ToolTip text="Report">
          <span className={'fa fa-flag-o ' + style.icon}  onClick={this.toggleVisibility} />
        </ToolTip>
        <LightboxComponent closePreview={this.toggleVisibility} isVisible={this.state.isVisible} small={true}>
          <ReportFeedForm postId={this.props.postId} />
        </LightboxComponent>
      </div>
    );
  }
}
